import { mapGetters, mapActions } from 'vuex';
import GcAlert from '@garmin/components-global/src/components/GcAlert/index.vue';

export default {
  name: 'FlashMessages',
  data() {
    return {
      className: 'app__product__flash-messages',
    };
  },
  components: {
    GcAlert,
  },
  computed: {
    ...mapGetters({
      messages: 'getFlashMessages',
    }),
  },
  methods: {
    ...mapActions([
      'removeFlashMessage',
    ]),
    closeable(msg) {
      return !!msg.onClose;
    },
    onClose(msg, index) {
      msg.onClose();
      this.removeFlashMessage(index);
    },
  },
};
